import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import HourRentalBasicRateDrawer from "components/drawer/HourRentalBasicRateDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ShowHideButton from "components/table/ShowHideButton";

// internal imports

const HourRentalBasicRateTable = ({
  hourRentalBasicRate,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  const hourRentalBasicRatesorted = hourRentalBasicRate.sort((a, b) =>
    a.city.localeCompare(b.city)
  );
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <HourRentalBasicRateDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {hourRentalBasicRatesorted?.slice(0, perpage).map((data, index) => (
          <React.Fragment key={data.id}>
            {data["vehicle_type_id"].map((item, vehicleIndex) => (
              <TableRow key={`${data.id}-${vehicleIndex}`}>
                {vehicleIndex === 0 && (
                  <>
                    <TableCell
                      className="text-sm text-center"
                      rowSpan={data["vehicle_type_id"].length}
                    >
                      {(currentPage - 1) * perpage + index + 1}
                    </TableCell>
                    <TableCell
                      className="text-sm text-center"
                      rowSpan={data["vehicle_type_id"].length}
                    >
                      {data["city"]}
                    </TableCell>
                  </>
                )}

                <TableCell className="text-sm text-center">
                  {data["vehicle_type_names"][item]}
                </TableCell>
                {/* <TableCell className="text-sm text-center">
                  {data["4h_40km"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["6h_60km"][item]}
                </TableCell> */}
                <TableCell className="text-sm text-center">
                  {data["8h_80km"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["10h_100km"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["extra_km"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["extra_hr"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["prime"][item] + "%"}
                </TableCell>

                
                  {vehicleIndex === 0 && (<TableCell
                  className="text-sm text-center"
                  rowSpan={data["vehicle_type_id"].length}
                >
                    <ShowHideButton
                      id={data.id}
                      status={data.is_active}
                      Loading={true}
                    />
                      </TableCell>
                  )}
              

                {vehicleIndex === 0 && (
                  <TableCell rowSpan={data["vehicle_type_id"].length}>
                    <div className="flex justify-center">
                      <EditDeleteButton
                        title={data["Hour Rental"]}
                        id={data.id}
                        handleUpdate={handleUpdate}
                        handleModalOpen={handleModalOpen}
                        hideDelete={hideDelete}
                        hideEdit={hideEdit}
                      />
                    </div>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </React.Fragment>
        ))}
      </TableBody>
    </>
  );
};

export default HourRentalBasicRateTable;
